/* Video with image overlay — assets/video-overlay.js (jQuery)
   Loads jQuery automatically if the theme doesn't already include it.
   Click the overlay → the video plays inline (or in a popup), like Elementor's
   "Image overlay" video widget. The iframe/video is only created on click (lazy).
*/
(function () {
  function init($) {

    function embedHtml(d) {
      var params;
      if (d.type === 'youtube') {
        params = 'autoplay=1&rel=0&playsinline=1&modestbranding=1' + (d.controls ? '' : '&controls=0') + (d.mute ? '&mute=1' : '') + (d.loop ? '&loop=1&playlist=' + d.id : '');
        return '<iframe src="https://www.youtube' + (d.nocookie ? '-nocookie' : '') + '.com/embed/' + d.id + '?' + params +
          '" title="' + (d.title || 'Video') + '" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>';
      }
      if (d.type === 'vimeo') {
        params = 'autoplay=1' + (d.mute ? '&muted=1' : '') + (d.loop ? '&loop=1' : '');
        return '<iframe src="https://player.vimeo.com/video/' + d.id + '?' + params +
          '" title="' + (d.title || 'Video') + '" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
      }
      return null; // shopify video handled separately
    }

    function setup($root) {
      if ($root.data('voInit')) return;
      $root.data('voInit', true);

      var $overlay = $root.find('[data-vo-play]');
      var $player = $root.find('[data-vo-player]');
      var d = $overlay.data();
      var cfg = {
        type: d.voType, id: d.voId, mode: d.voMode, controls: d.voControls !== false,
        mute: d.voMute === true, loop: d.voLoop === true, nocookie: d.voNocookie === true, title: d.voTitle
      };

      // YouTube thumbnail fallback when no overlay image is uploaded
      var $thumb = $overlay.find('img[data-vo-yt-thumb]');
      $thumb.on('error', function () {
        if (this.src.indexOf('maxresdefault') > -1) this.src = this.src.replace('maxresdefault', 'hqdefault');
      });

      function nativeVideo($into) {
        var $tpl = $root.find('template[data-vo-native]');
        if (!$tpl.length) return null;
        var $v = $($tpl.html()).filter('video').first();
        if (!$v.length) $v = $($tpl.html()).find('video').first();
        $into.empty().append($v);
        var v = $v[0];
        if (v) {
          v.controls = cfg.controls; v.muted = cfg.mute; v.loop = cfg.loop; v.playsInline = true;
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        }
        return v;
      }

      // ---- inline ----
      function playInline() {
        var html = embedHtml(cfg);
        if (html) $player.html(html); else nativeVideo($player);
        $overlay.addClass('is-hidden').attr('tabindex', '-1');
      }

      // ---- popup ----
      var $modal = $root.find('.vo-modal');
      var $frame = $modal.find('.vo-modal__frame');
      if ($modal.length) $modal.appendTo(document.body);
      function openPopup() {
        var html = embedHtml(cfg);
        if (html) $frame.html(html); else nativeVideo($frame);
        $modal.addClass('is-open');
        $('body').addClass('vo-lock');
        $modal.find('.vo-modal__close').trigger('focus');
      }
      function closePopup() {
        $modal.removeClass('is-open');
        $('body').removeClass('vo-lock');
        $frame.empty();
        $overlay.trigger('focus');
      }
      $modal.on('click', '[data-vo-close]', closePopup);
      $(document).on('keydown', function (e) { if (e.key === 'Escape' && $modal.hasClass('is-open')) closePopup(); });

      $overlay.on('click', function (e) {
        e.preventDefault();
        if (cfg.mode === 'popup') openPopup(); else playInline();
      });
    }

    $(function () { $('[data-vo]').each(function () { setup($(this)); }); });
    $(document).on('shopify:section:load', function (e) {
      $(e.target).find('[data-vo]').each(function () { setup($(this)); });
    });
    $(document).on('shopify:section:unload', function (e) {
      var id = $(e.target).find('[data-vo]').attr('data-vo');
      if (id) $('.vo-modal[data-vo-modal="' + id + '"]').remove();
    });
  }

  if (window.jQuery) {
    init(window.jQuery);
  } else {
    var s = document.createElement('script');
    s.src = 'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.7.1/jquery.min.js';
    s.onload = function () { init(window.jQuery); };
    document.head.appendChild(s);
  }
})();
